<template>
	<div class="plr-16 box-s" :class="{'pb-30': padShow }" id="nodes">
    <div v-for="(item, index) in list" class="" :key="index">
      <!-- 头部题型和题数 -->
      <div :class="{ 'pt-66': item.is_stuff_question }" v-if="qusetNum == (index + 1)">
          <div class="quest_header flexs h66 bg_f" :class="{ 'ps_top': item.is_stuff_question, 'plr-16': item.is_stuff_question }">
            <div class="c1 fz-16 mb-6"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>
            <template v-if="!item.is_stuff_question">
              <div v-if="item.question_type == 1" class="tag_class ml-5 bg_ff c13">单选题</div>
              <div v-if="item.question_type == 2" class="tag_class ml-5 bg_dc c12">多选题</div>
              <div v-if="item.question_type == 3" class="tag_class ml-5 bg_ea c11">判断题</div>
              <div v-if="item.question_type == 5" class="tag_class ml-5 bg_d8 c0">填空题</div>
              <div v-if="item.question_type == 4" class="tag_class ml-5 bg_d8 c0">简答题</div>
            </template>
            <div v-else class="tag_class ml-5 bg_bb c16">材料题</div>
          </div>
        </div>

      <div v-if="item.is_stuff_question && qusetNum == (index + 1)" class="pt-155">
        <div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s">
          <div class="over-auto cail trans" :ref="'DOM' + index" :style="{ 'height': cheight + 'px' }">
            <div class="fz-14 fw-500 c1"  v-html="item.stuff"></div>
          </div>
          <div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40" @click="showHe(index)">
            <div class="flexs flex-center l-h-40" v-if="showFlag">
              <div>{{txtflag? '收起': '展开'}}</div>
              <span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
              <span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="qusetNum == (index + 1)" class="fz-14 fw-500 c1 mb-22" v-html="item.question_stem"></div>


      <!-- 单选题 -->
      <ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 1)">
        <li class="flexs mb-22 pd-20-16  b-radius-6 bg_f8 box-s flex-jus bb-ff" :class="{ 'checked': item.right_answer[0] == Object.keys(innerItem)[0], 'error_checked': item.student_answer[0] == Object.keys(innerItem)[0] && item.right_answer[0] != Object.keys(innerItem)[0] }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex">
          <div class="flexs">
            <div class="">{{Object.keys(innerItem)[0] }}.</div>
            <div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
          </div>
					<div class="ml-10">
						<img v-if=" item.student_answer[0] == Object.keys(innerItem)[0] && item.right_answer[0] != Object.keys(innerItem)[0]" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
						<img v-else-if="item.right_answer[0] == Object.keys(innerItem)[0]" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
						
					</div>
        </li>
      </ul>

      <!-- 判断题 -->
      <ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 3)">
        <li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 box-s bb-ff" :class="{ 'checked': item.right_answer == 'true', 'error_checked': item.student_answer == 'true' && item.right_answer == 'false' }">
          <div class="flexs">
            <div class="">A.</div>
            <div class="ml-6" >正确</div>
          </div>

					<div class="ml-10">
						<img v-if="item.student_answer == 'true' && item.right_answer == 'false'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
						<img v-else-if="item.right_answer == 'true'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
						
					</div>
        </li>

        <li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 box-s bb-ff" :class="{ 'checked': item.right_answer == 'false', 'error_checked': item.student_answer == 'false' && item.right_answer == 'true' }">
          <div class="flexs">
            <div class="">B.</div>
            <div class="ml-6" >错误</div>
          </div>

					<div class="ml-10">
						<img v-if="item.student_answer == 'false' && item.right_answer == 'true'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
						<img v-else-if="item.right_answer == 'false'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
					</div>
        </li>
        
      </ul>
      

      <!-- 多选题 -->
      <ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 2)">
        <li class="flexs flex-jus mb-22 pd-20-16  b-radius-6 bg_f8 box-s bb-ff" :class="{ 'checked': item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1, 'error_checked': item.right_answer.indexOf(Object.keys(innerItem)[0]) == -1 && item.student_answer.indexOf(Object.keys(innerItem)[0]) != -1,'tag_active': item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1 && item.student_answer.indexOf(Object.keys(innerItem)[0]) == -1}" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex">
          <div class="flexs">
            <div class="">{{Object.keys(innerItem)[0]}}.</div>
            <div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
          </div>

					<div class="ml-10">
						<img v-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) == -1 && item.student_answer.indexOf(Object.keys(innerItem)[0]) != -1" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
						<div v-else-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1 && item.student_answer.indexOf(Object.keys(innerItem)[0]) == -1" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
						<img v-else-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
						
					</div>
        </li>
      </ul>

      <!-- 填空题/简答题 -->
      <div v-if="qusetNum == (index + 1) && (item.question_type == 4 || item.question_type == 5)">
        <div  class="textarea_box mb-12">
          <textarea v-model="item.student_answer" class="textarea" name="" id="" cols="30" rows="10" readonly></textarea>
        </div>

        <div class="mb-22" v-if="item.answer_picture">
          <addImg :imgList="item.answer_picture" :showDel="false" :showAdd="false"/>
        </div>
      </div>

			<!-- 答案 -->
      <div class="animal pt-22" v-if="qusetNum == (index + 1)">
				<div class="mb-22">
					<div class="flexs flex-jus fw-500 c1">
						<div class="flexs">
							<img class="wh_32 mr-10" src="../../assets/img/icon/answer_icon.png" alt="">
							<div class="l-h-16 fz-16  ">题目解析～巩固你的知识吧！</div>
						</div>
						<div class="flexs fz-10 bg_f9 flex-center b-radius-10 wh_74_20" @click="jumpReaction">
							纠错反馈
							<img class="wh_4_6 ml-8" src="../../assets/img/icon/gray_right_arrow_icon.png" alt="">
						</div>
					</div>
				</div>

				<div class="fz-14 fw-500 c1 mb-10" :class="{ 'flexs': !(item.question_type == 4 || item.question_type == 5) }">
					<div class="mr-30 flexs flex-align-start " >
            <div class="w75 wrp">正确答案：</div>
            <div class="c0 flex1" v-html="item.right_answer" v-if="item.question_type == 4 || item.question_type == 5">
            </div> 

            <div class="c0 flex1" v-else>
              {{!Array.isArray(item.right_answer)? (item.right_answer === ''? '暂无': item.right_answer == 'true'? '正确': item.right_answer == 'false'? '错误': item.right_answer): (item.right_answer.length == 0? '':(item.right_answer.length == 1? item.right_answer[0]: item.right_answer.join(''))) }}
            </div> 
          </div>

					<div class="flex flex-align-start">
						<div class="w75 wrp">你的答案：</div>
						<div class="c0 flex1" :class="{ 'c9': item.is_result == 0 || item.is_result == 2}">
							{{ !Array.isArray(item.student_answer)? (item.student_answer === ''? '未答': (item.student_answer == 'true'? '正确': item.student_answer == 'false'?'错误':item.student_answer)): (item.student_answer.length == 0? '未答':(item.student_answer.length == 1? item.student_answer[0]: item.student_answer.join('')))}}
						</div> 
					</div>
          
					
				</div>
				<div class="mb-10" v-if="item.answer_picture">
					<addImg :imgList="item.answer_picture" :showDel="false" :showAdd="false"/>
				</div>

				<div class="fz-14  c1">
					<div class="fw-500 mb-8">题目解析：</div>
					<div v-if="item.analysis" v-html="item.analysis"></div>
				</div>
			</div>

    </div>
		<loading :loadFlag="loadFlag"></loading>
    <qusetBottom :questBtn="questBtn" :length="length" :cData="cData" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" ></qusetBottom>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import { practiceExamComeOut } from '@/api/api.js'
	import {getShowPadding, formatTime} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	import addImg from "@/components/addImg.vue";
	export default {
		components: {
      qusetBottom,
			addImg,
      loading
		},
		data() {
			return {
        loadFlag: false,
        length: 0,
        number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],//题目前序号
				collectFalg: false, //是否收藏
        list: [], //题数据
				qusetNum: 1, //第几道题
				padShow: false, //是否展示底部30padding
        cData: {
          question_id: '',
          model_type: 7,
          way: 3, 
          base_user_id: ''
        },
				// question_type: 0, // 题的类型 1-单选 2-多选 3-判断 4-简答 5-填空 6-材料 

				showHeader: false, //材料题头部动画
				hideHeader: false,//材料题头部动画
				flag: false,//材料题头部动画
				txtflag: false,//材料题头部动画
				timeflag: false,//材料题头部动画
        questBtn: false,
        cheight: '',
				commonHeight: '',
				showFlag: false
			};
		},
		created() {
      this.qusetNum = this.$route.query.qusetNum? Number(this.$route.query.qusetNum) : 1
      this.cData.base_user_id = this.$route.query.practice_exam_user_id
      this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		methods: {
      init(){
        this.showHeader = false
        this.flag = false
        this.txtflag = false
        this.timeflag = false
			},
      async initData(){
        this.loadFlag = true
        const res = await practiceExamComeOut({ practice_exam_user_id: this.$route.query.practice_exam_user_id })
        this.loadFlag = false
        if( res.code == 1000 ){
          this.list = res.data
          this.length = this.list.length
          this.collectFalg = this.list[this.qusetNum - 1].question_wrong_id? true: false
          this.cData.question_id = this.list[this.qusetNum - 1].question_id
          this.getCliao()
          this.form = this.list.map(item => ({is_result: item.is_result}))
          
        } else {
          this.$toast(res.msg)
        }
			},

      getCliao(){
				this.cheight = ''
				this.commonHeight = ''
				this.showHeader = false
				this.txtflag = false
        if(this.list[this.qusetNum - 1].is_stuff_question){
					this.$nextTick(()=>{
						const r = document.documentElement.clientWidth / 375
						this.commonHeight = this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].offsetHeight * r:this.$refs['DOM'+ (this.qusetNum - 1)].offsetHeight
						this.cheight = 98 * r
						this.showFlag = this.commonHeight > this.cheight
						console.log(1111, this.commonHeight, this.cheight,this.$refs['DOM'+ (this.qusetNum - 1)][0])
					})
				}
			},

			// 上一页，下一页
			getQuest(type){
        this.init()
				document.body.scrollTop = document.documentElement.scrollTop = 0;
        if(type == '1'){
          this.qusetNum -= 1
        } else if (type == '2') {
          this.qusetNum += 1
        }
        this.getCliao()
        this.cData.question_id = this.list[this.qusetNum - 1].question_id
        this.collectFalg = this.list[this.qusetNum - 1].question_wrong_id? true: false
				
			},
      

			// 收藏
			collect(collectFalg){
				!collectFalg && this.$toast('已收藏至错题本')
        this.collectFalg = !collectFalg
        this.list[this.qusetNum - 1].question_wrong_id = !collectFalg? true: false
			},

			// 查看答题卡
			quertCard(data){
        if(!data){
          const form = JSON.stringify(this.form)
          this.$router.replace({path: '/inmitanalycard', query:{form, practice_exam_user_id: this.$route.query.practice_exam_user_id, qusetNum: this.qusetNum} })
        }
				
			},
      
			// 材料题展开收起
			showHe(){
				  if(!this.showFlag) return
          if(!this.showHeader){
            const h = document.documentElement.clientHeight * (document.documentElement.clientWidth / 375) * 0.55
						this.cheight = this.commonHeight > h ? h : this.commonHeight
					} else {
						this.cheight = 98 * (document.documentElement.clientWidth / 375)
						this.$nextTick(() => {
								this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].scrollTo(0,0): this.$refs['DOM'+ (this.qusetNum - 1)].scrollTo(0,0);
						})
					}
					
          this.showHeader = !this.showHeader
					this.txtflag = this.showHeader
				
        
			},
			jumpReaction(){
        this.$router.replace({ path: '/reaction', query: { practice_exam_user_id: this.$route.query.practice_exam_user_id, qusetNum: this.qusetNum, question_id: this.list[this.qusetNum - 1].question_id, type: 'imit'  } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}

.animal {
	animation: show 1s;
	animation-fill-mode:forwards;
}

@keyframes show {
	0% {
		display: none;
	}
	100% {
		display: block;
	}
}


</style>
